var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-icon-button',{attrs:{"size":_setup.props.size,"has-dropdown":"","icon":"info_outline","type":"secondary"}},[_c('div',{staticClass:"my-custom-dropdown",staticStyle:{"max-width":"300px","padding":"1rem 1rem .5rem"},attrs:{"slot":"dropdown"},slot:"dropdown"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }